export const formatDateToYearMonth = (
  date: Date,
  identifier?: string | null
) => {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");

  if (!identifier) identifier = ".";

  return `${year}${identifier}${month}`;
};

export const formatDateToYearMonthDay = (
  date: Date,
  identifier?: string | null
) => {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");

  if (!identifier) identifier = ".";

  return `${year}${identifier}${month}${identifier}${day}`;
};

// yyyy-mm-dd
// 2025-06-30
export const formatDateToKoreaTime = (date: Date) => {
  const koreaTime = new Date(date.getTime() + 9 * 60 * 60 * 1000);
  return koreaTime.toISOString().split("T")[0];
};

/**
 * yyyy.mm.dd(d) 형식으로 반환
 * @param date
 * @returns yyyy.mm.dd(d)
 */
export function formatDateToYearMonthDayDayOfWeek(
  date: Date,
  identifier?: string | null
) {
  const dayOfWeek = ["일", "월", "화", "수", "목", "금", "토"][date.getDay()];
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");

  if (!identifier) identifier = ".";

  return `${year}${identifier}${month}${identifier}${day} (${dayOfWeek})`;
}

/**
 * yyyy.mm.dd(d) hh:mm 형식으로 반환
 * @param date
 * @returns yyyy.mm.dd(d) hh:mm
 */
export function formatDateToYearMonthDayDayOfWeekHourMinute(
  date: Date,
  identifier?: string | null
) {
  const dayOfWeek = ["일", "월", "화", "수", "목", "금", "토"][date.getDay()];
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  const hour = String(date.getHours()).padStart(2, "0");
  const minute = String(date.getMinutes()).padStart(2, "0");

  if (!identifier) identifier = ".";

  return `${year}${identifier}${month}${identifier}${day} (${dayOfWeek}) ${hour}:${minute}`;
}

/**
 * yyyy-mm-dd hh:mm 형식으로 반환
 * @param date
 * @returns yyyy-mm-dd hh:mm
 */
export function formatDateToYYYYMMDDhhmm(date: Date): string {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  const hours = String(date.getHours()).padStart(2, "0");
  const minutes = String(date.getMinutes()).padStart(2, "0");

  return `${year}-${month}-${day} ${hours}:${minutes}`;
}

/**
 * 객체 형식으로 날짜 포맷 함수
 * @param date
 * @returns { date: string, time: string }
 */
export const formatDateToDateAndTimeObject = (date: Date) => {
  const dateObj = new Date(date);

  return {
    date: dateObj.toLocaleDateString("ko-KR", {
      year: "numeric",
      month: "long",
      day: "numeric",
    }),
    time: dateObj.toLocaleTimeString("ko-KR", {
      hour: "2-digit",
      minute: "2-digit",
      hour12: false,
    }),
  };
};

/**
 * "오전" 추가 시간 포맷팅
 * @param time 시간 문자열 (HH:mm)
 * @returns "오전" 추가된 시간 문자열 (ex. 오전 11:30)
 */
export function formatTimeWithAM(time: string) {
  if (!time) return "-";
  const [hours] = time.split(":");
  const hour = parseInt(hours);

  if (hour < 12) {
    return `오전 ${time}`;
  } else {
    return `${time}`;
  }
}
